module.exports = __webpack_public_path__ + "static/img/78073A_R_03_20170816_LC.db2b51d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78073A_R_03_20170816_LC.png
// module id = 4R2D
// module chunks = 0